import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { firestore } from "../../db/config";
import Alert from "../alert/alert";
import "./support.css";
export default function SupportButton() {
  const dispatch = useDispatch();
  const userRandomNumber = JSON.parse(
    localStorage.getItem("persist:userNumber")
  );

  const getRendomNumber = userRandomNumber
    ? JSON.parse(userRandomNumber.userRandomNumber)
    : "";

  const convertNumber = String(getRendomNumber.userRandomNumber);
  const handleOpenMessage = () => {
    dispatch({ type: "toggle_state", data: "block" });
    firestore
      .collection("customerMessages")
      .doc(convertNumber)
      .collection("messages")
      .where("fromUser", "==", "admin")
      .get()
      .then((data) => {
        data.docs.map((get) => {
          firestore
            .collection("customerMessages")
            .doc(convertNumber)
            .collection("messages")
            .doc(get.id)
            .update({ read: true });
        });
      });
  };

  const toggleReducer = useSelector((state) => state.toggleReducer);
  const toggle = toggleReducer.toggle;
  const [messageStatus, setmessageStatus] = useState({
    message: "you have a new message.",
    status: "danger",
    buttonStatus: false,
  });
  const getUnreadReducer = useSelector((state) => state.getUnreadReducer);
  const getUnreadMessage = getUnreadReducer.unread;

  return (
    <div className="support__button__cover" style={{ transition: "all .3s" }}>
      {getUnreadMessage.length ? <Alert details={{ ...messageStatus }} /> : ""}
      <button className="support__button" onClick={handleOpenMessage}>
        <span style={{ marginRight: "5px" }}>
          {getUnreadMessage.length ? (
            <img src="images/notification.png" alt="speach-logo" />
          ) : (
            <img src="images/speech-bubble.png" alt="speach-logo" />
          )}
        </span>
        Support
      </button>
    </div>
  );
}
